import React from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SaveIcon from '@material-ui/icons/Save';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import DeleteIcon from '@material-ui/icons/Delete';
import PublishIcon from '@material-ui/icons/Publish';
import {UploadActScanDialog} from "../UploadActScanDialog/UploadActScanDialog";
import {useDialog} from "../../../hooks/useDialog";
import {Statuses} from "../../../utils/actStatuses";
import {UserRoles} from "../../../utils/roles";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import {  getSelectedAct } from '../../../redux/reducers/act-reducer';
import { useDispatch, useSelector } from 'react-redux';
import { copyActContent, copyActData, finishedCopy, getActTemplate, getActTemplateProject, setCopyActData } from '../../../redux/reducers/act-template-reducer';
import { getProfile } from '../../../redux/reducers/user-profile-reducer';


const ActFillingHeaderTitles = {
    [Statuses.IN_WORK_STATUS]: {
        [UserRoles.SUPERVISOR]: 'Создание',
    },
    [Statuses.FOR_APPROVAL_STATUS]: {
        [UserRoles.SUPERVISOR]: 'Просмотр',
        [UserRoles.MODERATOR]: 'Модерация',
        [UserRoles.PROJECT_MANAGER]: 'Модерация',
        [UserRoles.EDITOR]: 'Модерация',
        [UserRoles.FIELD_CONTRACTOR]: 'Просмотр'

    },
    [Statuses.REJECTED_STATUS]: {
        [UserRoles.SUPERVISOR]: 'Редактирование',
        [UserRoles.MODERATOR]: 'Просмотр',
        [UserRoles.EDITOR]: 'Просмотр',
        [UserRoles.PROJECT_MANAGER]: 'Просмотр',
        [UserRoles.FIELD_CONTRACTOR]: 'Редактирование'
    },
    [Statuses.APPROVED_STATUS]: {
        [UserRoles.SUPERVISOR]: 'Просмотр',
        [UserRoles.MODERATOR]: 'Просмотр',
        [UserRoles.EDITOR]: 'Просмотр',
        [UserRoles.EMPLOYER]: 'Просмотр',
        [UserRoles.PROJECT_MANAGER]: 'Просмотр',
        [UserRoles.FIELD_CONTRACTOR]: 'Просмотр',
    },
    [Statuses.STATUS_SIGNED]: {
        [UserRoles.SUPERVISOR]: 'Подписан',
        [UserRoles.MODERATOR]: 'Подписан',
        [UserRoles.EDITOR]: 'Подписан',
        [UserRoles.EMPLOYER]: 'Подписан',
        [UserRoles.PROJECT_MANAGER]: 'Подписан',
        [UserRoles.FIELD_CONTRACTOR]: 'Подписан',
    }
}

export const SearchSignature = (fieldTemplates) => {
    let massSignatures = []
    let massVariables = []

    fieldTemplates.map((el) => {
        massSignatures = fieldTemplates.filter(el => el.type === 'signature-field')
    })

    massSignatures.map((el) => {
        massVariables.push(el.variable)
    })

    return massVariables
}


const SaveButton = ({onClick}) => <Button onClick={onClick}
                                          startIcon={<SaveIcon/>}
                                          size={"small"}
                                          style={{color: '#6F6F6F99'}}
>
    Сохранить черновик
</Button>

const ConfirmActButton = ({onClick}) => <Button onClick={onClick}
                                                startIcon={<ThumbUpIcon/>}
                                                size={"small"}
                                                style={{color: '#12900FB2'}}
>
    Подтвердить акт
</Button>

const RejectActButton = ({onClick}) => <Button onClick={onClick}
                                               startIcon={<ThumbDownIcon/>}
                                               size={"small"}
                                               style={{color: '#D53535B2'}}
>
    Отклонить акт
</Button>

const DeleteActButton = ({onClick}) => <Button onClick={onClick}
                                               startIcon={<DeleteIcon/>}
                                               size={"small"}
                                               style={{color: 'rgba(213,53,53,0.7)'}}
>
    Удалить черновик
</Button>

const UploadActScanButton = ({
                                 files,
                                 creator,
                                 handleActScan
                             }) => {
    const {open, handleClose, handleOpen} = useDialog()

    return <>
        <Button onClick={handleOpen}
                startIcon={<PublishIcon/>}
                size={"small"}
        >
            Загрузить скан акта
        </Button>
        {open ? <UploadActScanDialog open={open}
                                     files={files}
                                     creator={creator}
                                     handleActScan={handleActScan}
                                     handleClose={handleClose}/> : null}
    </>
}

const ActFillingHeaderButtons = ({
                                     role,
                                     status,
                                     isStaff,
                                     creator,
                                     files,
                                     handleActScan,
                                     handleSaveActDraftButton,
                                     handleActApproveButton,
                                     handleActRejectButton,
                                     handleDeleteActDraftButton
                                 }) => {
                                    
    
        return <Grid xs item>
            <UploadActScanButton files={files}
                                 creator={creator}
                                 handleActScan={handleActScan}/>
        </Grid>
    
    if (status) {
        if (status === Statuses.IN_WORK_STATUS && role === UserRoles.SUPERVISOR ) {
            return <Grid item xs container justifyContent={"space-between"}>
                <Grid item>
                    <UploadActScanButton files={files}
                                         creator={creator}
                                         handleActScan={handleActScan}/>
                </Grid>
                <Grid item xs container justifyContent={"flex-end"}>
                    <Grid item>
                        <SaveButton onClick={handleSaveActDraftButton}/>
                    </Grid>
                    <Grid item>
                        <DeleteActButton onClick={handleDeleteActDraftButton}/>
                    </Grid>
                </Grid>
            </Grid>
        }
        if (status === Statuses.REJECTED_STATUS && role === UserRoles.SUPERVISOR) {
            return <Grid xs item>
                <UploadActScanButton files={files}
                                     creator={creator}
                                     handleActScan={handleActScan}/>
            </Grid>
        }
        if (status === Statuses.FOR_APPROVAL_STATUS && (role === UserRoles.MODERATOR || role === UserRoles.PROJECT_MANAGER ||  role === UserRoles.EDITOR)) {
            return <Grid item xs container justifyContent={"space-between"}>
                <Grid item>
                    <UploadActScanButton files={files}
                                         creator={creator}
                                         handleActScan={handleActScan}/>
                </Grid>
                <Grid item xs container justifyContent={"flex-end"}>
                    <Grid item>
                        <ConfirmActButton onClick={handleActApproveButton}/>
                    </Grid>
                    <Grid item>
                        <RejectActButton onClick={handleActRejectButton}/>
                    </Grid>
                </Grid>
            </Grid>
        }
    } else {
        return <Grid item xs container justifyContent={"flex-end"}>
            <Grid item>
                <SaveButton onClick={handleSaveActDraftButton}/>
            </Grid>
        </Grid>
    }
    return null
}

export const ActFillingHeader = ({
                                     id,
                                     name,
                                     status,
                                     role,
                                     creator,
                                     isStaff,
                                     files,
                                     handleActScan,
                                     handleSaveActDraftButton,
                                     handleActApproveButton,
                                     handleActRejectButton,
                                     handleDeleteActDraftButton,
                                     setFieldValue,
                                     supervisor,
                                 }) => {

    const dispatch = useDispatch();
    const selectAct = useSelector(getSelectedAct)
    const copyActDataHeader = useSelector(copyActData)     
    const projectId = useSelector(getActTemplateProject)   
    const {user} = useSelector(getProfile) 
    

    if (copyActDataHeader !== null) {
        let dataActRaw = {...copyActDataHeader}
        for (const key in dataActRaw) {
            setFieldValue(key, dataActRaw[key])
        }
        dispatch(setCopyActData(null))
    }

    const handleCopyActButton =  () => {
        dispatch(copyActContent(projectId, selectAct, user.id))
    }

    return <Grid container direction={"row"} alignItems={"center"}>
        <Grid item>
            <Typography variant={"h6"}>
                {(id !== undefined) ?'#'+id : 'Новый документ'}
                {isStaff ? ' '+name : status ? ' '+ActFillingHeaderTitles[status][role]+' '+name : ''}
                {user.role === UserRoles.FIELD_CONTRACTOR && (supervisor?.full_name !== undefined) && ` Супервайзер: ${supervisor.full_name}`}
            </Typography>
        </Grid>

        {selectAct !== null &&
            <Button
            onClick={handleCopyActButton}
            startIcon={<FileCopyIcon 
                style={{
                    width: '24px',
                    height: '24px',
                }}/>}
            size={"small"}
        >
            Копировать Акт
        </Button>
        }
        
        <ActFillingHeaderButtons role={role}
                                 status={status}
                                 creator={creator}
                                 files={files}
                                 isStaff={isStaff}
                                 handleActScan={handleActScan}
                                 handleSaveActDraftButton={handleSaveActDraftButton}
                                 handleActApproveButton={handleActApproveButton}
                                 handleActRejectButton={handleActRejectButton}
                                 handleDeleteActDraftButton={handleDeleteActDraftButton}/>
    </Grid>
}